import { FormModaData, ProjectModaData } from "interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const dataFetchFromMoDaApi = coreApi.injectEndpoints({
  endpoints: builder => ({
    getProjects: builder.query<ProjectModaData[], { apiKeyId: number }>({
      query: ({ apiKeyId }) => ({ url: "DataFetchFromMoDa/Projects", method: "GET", params: { apiKeyId } }),
      keepUnusedDataFor: 60 * 60,
      providesTags: ["Projects"],
    }),

    getForms: builder.query<FormModaData[], { apiKeyId: number; projectId?: number }>({
      query: ({ apiKeyId, projectId }) => ({
        url: "DataFetchFromMoDa/Forms",
        method: "GET",
        params: { apiKeyId, projectId },
      }),
      keepUnusedDataFor: 60 * 60,
      providesTags: ["Forms"],
    }),

    testFetching: builder.mutation<{ statusCode: number; message: string }, { apiKeyId: number; formId: number }>({
      query: ({ apiKeyId, formId }) => ({
        url: "DataFetchFromMoDa/TestFetching",
        method: "GET",
        params: { apiKeyId, formId },
      }),
    }),
  }),
})

export const {
  useGetProjectsQuery,
  useLazyGetProjectsQuery,
  useGetFormsQuery,
  useLazyGetFormsQuery,
  useTestFetchingMutation,
} = dataFetchFromMoDaApi
